// extracted by mini-css-extract-plugin
export default {"wrapper":"R3vX77zXOOkAVOTDM_L3","emptyState":"IErAGju_vew_Y569x_6E","image":"NPAprmotYIgjX0yc4v9k","description":"MGx3t2uFVOuOX0C4AD7c"};